module.exports = __webpack_public_path__ + "static/bg7-b08234a2b7e8e4fb2e3c4e713252021c.jpg";